import React from "react";
import { AlertCircle, CheckCircle, Info } from "lucide-react";
import { cn } from "@/lib/utils";
import type { ToastState } from "./types";

const Toast: React.FC<{ toast: ToastState | null }> = ({ toast }) => {
  if (!toast) return null;
  return (
    <div
      className={cn(
        "fixed top-20 right-4 z-[200] flex items-start gap-3 px-4 py-3 rounded-xl shadow-lg border max-w-sm",
        toast.type === "success" && "bg-green-50 dark:bg-green-950 border-green-200 dark:border-green-800 text-green-800",
        toast.type === "error" && "bg-red-50 dark:bg-red-950 border-red-200 dark:border-red-800 text-red-800",
        toast.type === "info" && "bg-blue-50 dark:bg-blue-950 border-blue-200 dark:border-blue-800 text-blue-800 dark:text-indigo-300"
      )}
    >
      {toast.type === "success" && <CheckCircle className="w-4 h-4 mt-0.5 flex-shrink-0" />}
      {toast.type === "error" && <AlertCircle className="w-4 h-4 mt-0.5 flex-shrink-0" />}
      {toast.type === "info" && <Info className="w-4 h-4 mt-0.5 flex-shrink-0" />}
      <div>
        <p className="font-semibold text-sm">{toast.message}</p>
        {toast.desc && <p className="text-xs mt-0.5 opacity-80">{toast.desc}</p>}
      </div>
    </div>
  );
};

export default Toast;
